module.exports = __webpack_public_path__ + "static/media/StatsActive.32c50f83.svg";